import { FunctionsService } from './../common/functions.service';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class TagService {

  constructor( private functionsService: FunctionsService ) { }



  getTags(): string[]{

    let arr: string[] = [];

    arr.push('<<NOME_CANDIDATO>>');
    arr.push('<<SOBRENOME_CANDIDATO>>');
    arr.push('<<NOME_SOCIAL_OU_NOME_CANDIDATO>>');
    arr.push('<<NUMERO_INSCRICAO>>');
    arr.push('<<FORMA_INGRESSO>>');
    arr.push('<<NOME_CURSO>>');
    arr.push('<<MODALIDADE>>');
    arr.push('<<FORMACAO>>');
    arr.push('<<DOCUMENTOS_REPROVADOS>>');
    arr.push('<<DATA_PROVA>>');
    arr.push('<<HORA_INICIO_PROVA>>');
    arr.push('<<HORA_FIM_PROVA>>');
    arr.push('<<LOCAL_PROVA>>');
    arr.push('<<VALOR_INSCRICAO>>');
    arr.push('<<LINK_ALTERAR_SENHA>>');
    arr.push('<<CODIGO_VALIDACAO_EMAIL>>');
    arr.push('<<LINK_DOWNLOAD_BOLETO>>');
    arr.push('<<VALOR_BOLETO>>');
    arr.push('<<NOME_UNIDADE>>');
    arr.push('<<NOME_COMPLETO_UNIDADE>>');
    arr.push('<<ENDERECO_UNIDADE>>');
      
    return arr;

  }



  getTagName(tag: string): string{

    //retira os sinais << e >> da tag
    tag = tag.replace(/</g, '').replace(/>/g, '');
    
    if(tag == 'NOME_CANDIDATO'){
      return 'Nome do candidato';
    }

    if(tag == 'SOBRENOME_CANDIDATO'){
      return 'Sobrenome do candidato';
    }

    if(tag == 'NOME_SOCIAL_OU_NOME_CANDIDATO'){
      return 'Nome Social ou Nome do candidato';
    }

    if(tag == 'NUMERO_INSCRICAO'){
      return 'Número da inscrição';
    }

    if(tag == 'FORMA_INGRESSO'){
      return 'Forma de Ingresso';
    }

    if(tag == 'NOME_CURSO'){
      return 'Nome do curso';
    }

    if(tag == 'MODALIDADE'){
      return 'Modalidade';
    }

    if(tag == 'FORMACAO'){
      return 'Formação';
    }

    if(tag == 'DOCUMENTOS_REPROVADOS'){
      return 'Documento(s) Reprovado(s)';
    }

    if(tag == 'DATA_PROVA'){
      return 'Data da prova';
    }


    if(tag == 'HORA_INICIO_PROVA'){
      return 'Hora de início da prova';
    }


    if(tag == 'HORA_FIM_PROVA'){
      return 'Hora de encerramento da prova';
    }

    if(tag == 'LOCAL_PROVA'){
      return 'Local da prova';
    }

    if(tag == 'VALOR_INSCRICAO'){
      return 'Valor da inscrição';
    }

    if(tag == 'LINK_ALTERAR_SENHA'){
      return 'Link para alterar senha';
    }

    if(tag == 'CODIGO_VALIDACAO_EMAIL'){
      return 'Código para validar o email';
    }
    
    if(tag == 'LINK_DOWNLOAD_BOLETO'){
      return 'Link para download do boleto';
    }

    if(tag == 'VALOR_BOLETO'){
      return 'Valor do boleto';
    }
    
    if(tag == 'NOME_UNIDADE'){
      return 'Nome da unidade';
    }
    
    if(tag == 'NOME_COMPLETO_UNIDADE'){
      return 'Nome completo da unidade';
    }
    
    if(tag == 'ENDERECO_UNIDADE'){
      return 'Endereço da unidade';
    }
    

    return '';

  }


}
